import { Typography, TypographyProps } from '@mui/material';
import { Colors, Margins } from '../themes';

const BulletedText: React.FC<TypographyProps> = ({ children, sx, color, variant, ...rest }) => {
  return (
    <Typography
      component='li'
      className='bulleted-text'
      color={color ?? Colors.secondaryBase}
      variant={variant}
      sx={{
        ...Margins.mt_xxxs,
        display: 'list-item',
        ...sx,
      }}
      {...rest}>
      {children}
    </Typography>
  );
};

export default BulletedText;
